import { apiClient } from '../config'

import type { AIQCReview, AIQCResponse, EventLog } from '../types'

export const aiQcService = {
  // Get all QC reviews
  async getAllReviews(): Promise<AIQCReview[]> {
    const response = await apiClient.get('/admin/ai-qc/reviews')
    return response.data
  },

  // Get pending reviews only
  async getPendingReviews(): Promise<AIQCReview[]> {
    const response = await apiClient.get('/admin/ai-qc/pending-reviews')
    return response.data
  },

  // Approve a review
  async approveReview(reviewId: string): Promise<{ message: string }> {
    const response = await apiClient.post(`/admin/ai-qc/reviews/${reviewId}/approve`, {})
    return response.data
  },

  // Reject a review
  async rejectReview(reviewId: string): Promise<{ message: string }> {
    const response = await apiClient.post(`/admin/ai-qc/reviews/${reviewId}/reject`, {})
    return response.data
  },

  // Get AI response content by ID
  async getAIResponse(responseId: string): Promise<AIQCResponse> {
    const response = await apiClient.get(`/admin/ai-qc/ai-response/${responseId}`)
    return response.data
  },

  async getFailedGenerations(): Promise<EventLog[]> {
    const response = await apiClient.get('/admin/ai-qc/failed-generations')
    return response.data
  },

  // Get QC review for specific order (if exists)
  async getReviewByOrderId(orderId: string): Promise<AIQCReview | null> {
    try {
      const reviews = await this.getAllReviews()
      return reviews.find(review => 
        review.session.metadata?.labOrderId === orderId ||
        review.session.metadata?.junctionLabOrderId === orderId
      ) || null
    } catch {
      return null
    }
  },
}